import { get, patch, destroy } from "./base";

const NotificationServ = {
    // Get notifications with optional role filtering
    getNotifications: (params) => get("/notifications", { params }),

    // Get unread count for specific role
    getUnreadCount: (role) => get("/notifications/unread-count", { params: { role } }),

    // Mark single notification as read
    markAsRead: (id) => patch(`/notifications/${id}/read`),

    // Mark all notifications as read for current user (optional role filter)
    markAllAsRead: (role) => patch("/notifications/read-all", { role }, { params: { role } }),

    // Delete all notifications for current user
    clearAll: (role) => destroy("/notifications/clear-all", { params: { role } }),
};

export default NotificationServ;
